import { View } from 'react-native';
import { ListItem } from '../../Core/List/ListItem';
import { Typography } from '../../Core/Typography/Typography';
import { cn } from '../../lib/utils';

export type ProductListHeaderType = {
  assetHeader: string;
  balanceHeader: string;
  percentageChangeHeader: string;
  className?: string;
};

export const ProductListHeader = ({
  assetHeader,
  balanceHeader,
  percentageChangeHeader,
  className,
}: ProductListHeaderType) => {
  return (
    <ListItem className={cn('p-0 bg-transparent', className)} pressable={false}>
      <View className="w-full flex-row">
        <View className="w-1/2 flex-row justify-start gap-4 items-center">
          <Typography size="small" className="text-neutral-200">
            {assetHeader}
          </Typography>
        </View>

        <View className="w-1/2 grid grid-cols-3 gap-4">
          <View className="flex items-end justify-center">
            <Typography size="small" className="text-neutral-200">
              {balanceHeader}
            </Typography>
          </View>
          <View className="flex items-end justify-center">
            <Typography size="small" className="text-neutral-200">
              {percentageChangeHeader}
            </Typography>
          </View>
        </View>
      </View>
    </ListItem>
  );
};
